import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPositions, getWorkTypes } from './api';

export const path = '/dashboard/kpi/application/list';

const PageKPIApplicationListDashboard: React.FC = (props) => {
  const KPIApplicationListDashboard = Loadable.Map({
    loader: {
      page: () => import('./page'),
      positions: getPositions,
      workTypes: getWorkTypes,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <KPIApplicationListDashboard {...props} />;
};

export default PageKPIApplicationListDashboard;
